import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'concatArray'
})
export class ConcatArrayPipe implements PipeTransform {

  transform(array: any[], separator = ', '): string { //array: (string | IdName)[]
    if (!array?.length) {
      return '';
    }

    return array.map(item => item?.name ?? item).filter(Boolean).join(separator);
  }
}
